import React from 'react';
import { Outlet /* , useParams */ } from 'react-router-dom';
import PaymentProvider from './PaymentProvider';

/* const types = ['service', 'contract', 'product', 'invoice']; */

const index = () => {
 return (
  <PaymentProvider>
   <Outlet />
  </PaymentProvider>
 );
};

export default index;
